module.exports = __webpack_public_path__ + "resources/img/img_gamebase_game2.4f51443098ca4a38dd4ae1509520651c.jpg";